module.exports = __webpack_public_path__ + "static/media/redbit.dca7a320.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/redbit.svg
// module id = 941
// module chunks = 0